import { Box, Card, CardContent, Chip, Skeleton, Typography } from '@mui/material';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getConfirmedOrders, getConfirmedOrdersLoader } from 'redux/reducers/orders/selectors';
import { COLORS } from 'services/constants/colors';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { CountryWithFlag } from 'ui/CountryWithFlag';
import { EasChip } from 'ui/EasChip';

export const DeliveryInformation: FC = () => {
	const orders = useSelector(getConfirmedOrders);
	const ordersIsLoading = useSelector(getConfirmedOrdersLoader);
	return (
		<div>
			{orders && !ordersIsLoading && orders?.data.length > 0 && (
				<Card
					sx={{
						mb: 2,
						'&': {
							borderRadius: '12px',
						},
					}}
				>
					<CardContent>
						<Typography sx={{ fontSize: 14 }} color="primary" gutterBottom>
							Delivery Information
						</Typography>
						<Typography sx={{ mt: 1.5 }} color="text.secondary">
							Customer:
						</Typography>
						<Typography variant="h6" component="div">
							{orders?.data?.[0]?.deliveryPerson}
						</Typography>
						{orders?.data?.[0]?.deliveryEmail && (
							<>
								<Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
									Email:
								</Typography>
								<Typography>{orders?.data?.[0]?.deliveryEmail || '—'}</Typography>{' '}
							</>
						)}
						{orders?.data?.[0]?.deliveryPhone && (
							<>
								<Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
									Phone number:
								</Typography>
								<Typography>{orders?.data?.[0]?.deliveryPhone || '—'}</Typography>{' '}
							</>
						)}
						{orders?.data?.[0].recipientCompanyName && (
							<>
								<Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
									Company name:
								</Typography>
								<Typography>{orders?.data?.[0].recipientCompanyName}</Typography>
							</>
						)}
						{orders?.data?.[0].recipientCompanyVat && (
							<>
								<Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
									Company VAT number:
								</Typography>
								<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
									<Typography>{orders?.data?.[0].recipientCompanyVat}</Typography>
									<EasChip
										label={orders?.data?.[0].recipientCompanyVatValidated?.replace('_', ' ')}
										// variant="outlined"
										bgcolor={
											orders?.data?.[0].recipientCompanyVatValidated === 'not_validated'
												? COLORS.WARNING
												: COLORS.SUCCESS
										}
									/>
								</Box>
							</>
						)}
						<Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
							Delivery Country:
						</Typography>
						<CountryWithFlag countryCode={orders?.data?.[0]?.deliveryCountry} />

						<Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
							Delivery Address:
						</Typography>
						<Typography>{orders?.data?.[0]?.deliveryAddress}</Typography>

						<Typography sx={{ mt: 1.5 }} variant="body2" color="text.secondary">
							Delivery Cost:
						</Typography>
						<AmountAndCurrency
							amount={orders?.data?.[0]?.deliveryCost ?? 0}
							currency={orders?.data?.[0]?.paymentCurrency}
							size={1}
						/>
					</CardContent>
				</Card>
			)}
			{ordersIsLoading && (
				<Skeleton variant="rectangular" height="300px" sx={{ borderRadius: '12px', mb: 2 }} />
			)}
		</div>
	);
};
